const Header = () => {

    return (
        <div className="header">
            <h2>Fox Angus Ranch. Est. 1999</h2><br></br>
        </div>
     );
}

export default Header;